module.exports = __webpack_public_path__ + "img/c1.9fc280a0.jpg";